export const getFlagUrl = (baseUrl: string, clientid: number, playerid: number) => {
    return `${baseUrl}mobile/getNationalFlag?clientid=${clientid}&playerid=${playerid}`
}
export const getStatisticCenterMatchURL = (statisticCenterBaseUrl: string, seasonid: number, matchid: number, lang: string, s5Alias: string = 'betradarvg') => {
    return `${statisticCenterBaseUrl}/${s5Alias}/${lang}/5/match/${matchid}`
}
    
export const getStatisticCenterTeamsURL = (statisticCenterBaseUrl: string, seasonid: number, teamA: number, teamB: number, lang: string, s5Alias: string = 'betradarvg') => {
    return `${statisticCenterBaseUrl}/${s5Alias}/${lang}/5/season/${seasonid}/h2h/${teamA}/${teamB}`
}